"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCircularInput = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_circular_input_1 = require("react-circular-input");
var ACCircularInput = function (props) {
    var _a = props.value, value = _a === void 0 ? 0 : _a, _b = props.maxValue, maxValue = _b === void 0 ? 360 : _b, _c = props.max, max = _c === void 0 ? 360 : _c, _d = props.step, step = _d === void 0 ? 10 : _d, _e = props.suffix, suffix = _e === void 0 ? '' : _e;
    var normalizedValue = value / maxValue;
    var handleChange = function (v) {
        var actual = Math.round((v * maxValue) / step) * step;
        if (max) {
            actual = Math.min(actual, max);
        }
        props.onChange && props.onChange(actual);
    };
    var getAngleFromValue = function (val, maxVal) {
        return (val / maxVal) * 360;
    };
    var renderMarkerAtValue = function (val) {
        if (max === maxValue)
            return;
        var angle = getAngleFromValue(val, maxValue);
        var rad = (angle - 90) * (Math.PI / 180);
        var r1 = 28; // inner radius
        var r2 = 42; // outer radius (longer bar)
        var thickness = 2; // thicker line
        return ((0, jsx_runtime_1.jsx)("line", { x1: 35 + r1 * Math.cos(rad), y1: 35 + r1 * Math.sin(rad), x2: 35 + r2 * Math.cos(rad), y2: 35 + r2 * Math.sin(rad), stroke: "#000000" // black
            , strokeWidth: thickness }, "marker-".concat(val)));
    };
    return ((0, jsx_runtime_1.jsx)("div", { className: "w-full d-center p-2 my-3 ".concat((props === null || props === void 0 ? void 0 : props.containerClassName) || ''), children: (0, jsx_runtime_1.jsxs)(react_circular_input_1.CircularInput, { name: props === null || props === void 0 ? void 0 : props.name, value: normalizedValue, onChange: function (v) { return handleChange(v); }, radius: 35, children: [(0, jsx_runtime_1.jsx)(react_circular_input_1.CircularTrack, { strokeWidth: 10 }), (0, jsx_runtime_1.jsx)(react_circular_input_1.CircularProgress, { strokeWidth: 10, markerWidth: 10, stroke: "#1E30D8" }), (0, jsx_runtime_1.jsx)(react_circular_input_1.CircularThumb, { strokeWidth: 10, radius: 2, r: 10, fill: "#1a29b8", className: "shadow-md" }), renderMarkerAtValue(0), " // min", renderMarkerAtValue(max), " // max", (0, jsx_runtime_1.jsxs)("text", { x: suffix ? 39 : 35, y: 35, textAnchor: "middle", dy: "0.3em", 
                    // fontSize="1em"
                    fontWeight: "bold", children: [value, suffix] })] }) }));
};
exports.ACCircularInput = ACCircularInput;
